var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiRrAlignLeft1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_83_911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.88281 6.65736H23.8828C24.148 6.65736 24.4024 6.552 24.5899 6.36447C24.7775 6.17693 24.8828 5.92258 24.8828 5.65736C24.8828 5.39215 24.7775 5.13779 24.5899 4.95026C24.4024 4.76272 24.148 4.65736 23.8828 4.65736H1.88281C1.6176 4.65736 1.36324 4.76272 1.17571 4.95026C0.988169 5.13779 0.882813 5.39215 0.882812 5.65736C0.882813 5.92258 0.988169 6.17693 1.17571 6.36447C1.36324 6.552 1.6176 6.65736 1.88281 6.65736Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.88281 11.6573H15.8828C16.148 11.6573 16.4024 11.552 16.5899 11.3645C16.7775 11.1769 16.8828 10.9226 16.8828 10.6573C16.8828 10.3921 16.7775 10.1378 16.5899 9.95024C16.4024 9.76271 16.148 9.65735 15.8828 9.65735H1.88281C1.6176 9.65735 1.36324 9.76271 1.17571 9.95024C0.988169 10.1378 0.882813 10.3921 0.882812 10.6573C0.882813 10.9226 0.988169 11.1769 1.17571 11.3645C1.36324 11.552 1.6176 11.6573 1.88281 11.6573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8828 14.6574H1.88281C1.6176 14.6574 1.36324 14.7627 1.17571 14.9503C0.988169 15.1378 0.882813 15.3922 0.882812 15.6574C0.882813 15.9226 0.988169 16.177 1.17571 16.3645C1.36324 16.552 1.6176 16.6574 1.88281 16.6574H23.8828C24.148 16.6574 24.4024 16.552 24.5899 16.3645C24.7775 16.177 24.8828 15.9226 24.8828 15.6574C24.8828 15.3922 24.7775 15.1378 24.5899 14.9503C24.4024 14.7627 24.148 14.6574 23.8828 14.6574Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_83_911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.882812 0.657349)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrAlignLeft1);
export default __webpack_public_path__ + "static/media/fi-rr-align-left (1).9617b69ac48206c0a69492734fa691dd.svg";
export { ForwardRef as ReactComponent };